export const isFileOrBlob = (value: any) => {
  return value instanceof Blob || value instanceof File;
};
